export class ShortUrlModel {
  constructor(data={}) {
    this._id = data._id || null;

    this.originalUrl = data.originalUrl || ''
    this.shortCode = data.shortCode || ''
    this.clickCount = Number(data.clickCount|| 0);
    this.shortUrl =  data.shortUrl || ''

    this.createdAt = data.createdAt || null;
  }

  isValid() {
    return this._id? true: false;
  }
}